/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestsnoevents4Inputs */

const en_statsroomguestsnoevents4 = /** @type {(inputs: Statsroomguestsnoevents4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No guest has been in a Live Room in the last 30 days.`)
};

const de_statsroomguestsnoevents4 = /** @type {(inputs: Statsroomguestsnoevents4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den letzten 30 Tagen war kein Gast in einem Live Room.`)
};

/**
* | output |
* | --- |
* | "No guest has been in a Live Room in the last 30 days." |
*
* @param {Statsroomguestsnoevents4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestsnoevents4 = /** @type {((inputs?: Statsroomguestsnoevents4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestsnoevents4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestsnoevents4(inputs)
	return de_statsroomguestsnoevents4(inputs)
});
export { statsroomguestsnoevents4 as "statsRoomGuestsNoEvents" }